import cdkOutputs from "../app/cdk-outputs.json" assert { type: "json" }

export interface CognitoConfig {
  region: string
  userPoolId: string
  userPoolClientId: string
}

function extractFromCdkOutputs(): Partial<CognitoConfig> {
  try {
    const entries = Object.values(cdkOutputs as Record<string, unknown>) as Array<Record<string, unknown>>
    const match = entries.find((v) => typeof v === "object" && v !== null && "UserPoolId" in v && "UserPoolClientId" in v)
    if (!match) return {}

    const userPoolId = String((match as Record<string, unknown>)["UserPoolId"]) || ""
    const userPoolClientId = String((match as Record<string, unknown>)["UserPoolClientId"]) || ""

    // Derive region from env if present, else infer from pool id prefix (e.g., us-east-1_XXXX)
    const inferredRegion = process.env.NEXT_PUBLIC_AWS_REGION || (userPoolId.includes("_") ? userPoolId.split("_")[0] : "")

    return {
      region: inferredRegion,
      userPoolId,
      userPoolClientId,
    }
  } catch {
    return {}
  }
}

export function getCognitoConfig(): CognitoConfig {
  const envRegion = process.env.NEXT_PUBLIC_AWS_REGION
  const envPoolId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID
  const envClientId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID

  const fromOutputs = extractFromCdkOutputs()

  const region = envRegion || fromOutputs.region || "us-east-1"
  const userPoolId = envPoolId || fromOutputs.userPoolId || ""
  const userPoolClientId = envClientId || fromOutputs.userPoolClientId || ""

  if (!userPoolId || !userPoolClientId) {
    throw new Error("Missing Cognito configuration. Ensure cdk-outputs.json or NEXT_PUBLIC_* envs are set.")
  }

  return { region, userPoolId, userPoolClientId }
}

const cognitoConfig = getCognitoConfig()
export default cognitoConfig


